import { render, staticRenderFns } from "./PartyBuildingDynamics.vue?vue&type=template&id=ed5c38ce&"
import script from "./PartyBuildingDynamics.vue?vue&type=script&lang=js&"
export * from "./PartyBuildingDynamics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports